import { z } from 'zod';
import { UuidSchema, EmailSchema, NonEmptyStringSchema } from './common.schema';

// User schemas
export const UserSchema = z.object({
  id: UuidSchema,
  name: NonEmptyStringSchema,
  email: EmailSchema.optional(),
  avatar_url: z.string().optional(),
});

export const AuthRequestSchema = z.object({
  email: EmailSchema,
  name: NonEmptyStringSchema,
});

export const AuthResponseSchema = z.object({
  accessToken: NonEmptyStringSchema,
  refreshToken: NonEmptyStringSchema.optional(),
  user: UserSchema,
});

export const LoginCredentialsSchema = z.object({
  email: EmailSchema,
  name: NonEmptyStringSchema,
});

export const RegisterDataSchema = z.object({
  email: EmailSchema,
  name: NonEmptyStringSchema,
});

export const UsersResponseSchema = z.object({
  users: z.array(UserSchema),
});

export const ApiKeyResponseSchema = z.object({
  apiKey: NonEmptyStringSchema,
});

// Derived types
export type User = z.infer<typeof UserSchema>;
export type AuthRequest = z.infer<typeof AuthRequestSchema>;
export type AuthResponse = z.infer<typeof AuthResponseSchema>;
export type LoginCredentials = z.infer<typeof LoginCredentialsSchema>;
export type RegisterData = z.infer<typeof RegisterDataSchema>;
export type UsersResponse = z.infer<typeof UsersResponseSchema>;
export type ApiKeyResponse = z.infer<typeof ApiKeyResponseSchema>;
